// src/constants/formOptions.js
export const GENDER_OPTIONS = [
    { value: 'male', label: 'Male' },
    { value: 'female', label: 'Female' },
    { value: 'other', label: 'Other' }
  ];
  
  export const YEAR_OPTIONS = [
    { value: '1', label: 'First Year' },
    { value: '2', label: 'Second Year' },
    { value: '3', label: 'Third Year' },
    { value: '4', label: 'Fourth Year' },
    { value: '5', label: 'Fifth Year' },

  ];

  export const SEM_OPTIONS = [
    { value: '1', label: 'January' },
    { value: '2', label: 'May' },
    { value: '3', label: 'September' },

  ];
  
  export const MARITAL_STATUS_OPTIONS = [
    { value: 'single', label: 'Single' },
    { value: 'married', label: 'Married' },
    { value: 'divorced', label: 'Divorced' },
    { value: 'widowed', label: 'Widowed' }
  ];